var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 356.78 493.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.1,493.65c-1.89.38-5.83.38-7.72,0-5.64-1.14-9.15-6.43-13.04-10.6-27.42-29.4-56.91-70.33-79.4-103.9C21,288.18-41.08,172.67,35.64,70.8c71.1-94.41,214.11-94.4,285.2,0,75.6,100.39,16.51,213.45-43.22,303.72-23.21,35.08-53.94,77.91-82.49,108.52-3.88,4.16-7.4,9.46-13.04,10.6ZM172.26,88.76c-68.71,4.8-107.62,82.76-68.52,140.3,35.46,52.18,112.81,52.61,148.61.57,42.53-61.83-5.64-146.06-80.08-140.86Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.8aa772ab1bfab716bc81f75fe2dfc236.svg";
export { ForwardRef as ReactComponent };